import i18n from '@/i18n';
import { getMblViewBreadCrumbs } from '@/modules/master-bl';
import { PermissionsImportFeatures } from '@/constants/permissions';
import { Route } from 'vue-router';

export const mblRoutes = [
  {
    name: 'MasterBLCreate',
    meta: {
      disableWarehouseSwitch: true,
      pageTitle: i18n.t('MBLCreate'),
      permission: PermissionsImportFeatures.MBL,
    },
    path: 'master-bl/create',
    component: () => import('@/views/master-bl/MasterBLCreateView.vue'),
  },
  {
    name: 'MasterBL',
    meta: {
      disableWarehouseSwitch: true,
      pageTitle: 'MBL',
      dynamicTitle: true,
      permission: PermissionsImportFeatures.MBL,
      breadCrumbs: getMblViewBreadCrumbs,
    },
    path: 'master-bl/view/:id',
    props: (route: Route) => ({ id: route.params.id }),
    component: () => import('@/views/master-bl/MasterBLView.vue'),
  },
];
